"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _ColleagueInvitationItem = _interopRequireDefault(require("./ColleagueInvitationItem"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The InviteColeaguesModel model module.
 * @module model/InviteColeaguesModel
 * @version 1.1.3-alpha.1
 */
class InviteColeaguesModel {
  /**
   * Constructs a new <code>InviteColeaguesModel</code>.
   * @alias module:model/InviteColeaguesModel
   * @param colleagues {Array.<module:model/ColleagueInvitationItem>} 
   */
  constructor(colleagues) {
    InviteColeaguesModel.initialize(this, colleagues);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj, colleagues) {
    obj['colleagues'] = colleagues;
  }

  /**
   * Constructs a <code>InviteColeaguesModel</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/InviteColeaguesModel} obj Optional instance to populate.
   * @return {module:model/InviteColeaguesModel} The populated <code>InviteColeaguesModel</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new InviteColeaguesModel();
      if (data.hasOwnProperty('colleagues')) {
        obj['colleagues'] = _ApiClient.default.convertToType(data['colleagues'], [_ColleagueInvitationItem.default]);
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>InviteColeaguesModel</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>InviteColeaguesModel</code>.
   */
  static validateJSON(data) {
    // check to make sure all required properties are present in the JSON string
    for (const property of InviteColeaguesModel.RequiredProperties) {
      if (!data[property]) {
        throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
      }
    }
    if (data['colleagues']) {
      // data not null
      // ensure the json data is an array
      if (!Array.isArray(data['colleagues'])) {
        throw new Error("Expected the field `colleagues` to be an array in the JSON data but got " + data['colleagues']);
      }
      // validate the optional field `colleagues` (array)
      for (const item of data['colleagues']) {
        _ColleagueInvitationItem.default.validateJSON(item);
      }
      ;
    }
    return true;
  }
}
InviteColeaguesModel.RequiredProperties = ["colleagues"];

/**
 * @member {Array.<module:model/ColleagueInvitationItem>} colleagues
 */
InviteColeaguesModel.prototype['colleagues'] = undefined;
var _default = exports.default = InviteColeaguesModel;